import React, { useState } from 'react';
import { toast } from 'react-toastify';
import style from './kyc.module.css';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const Kyc = () => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [address, setAddress] = useState('');
  const [doc, setDoc] = useState();
  const curUser = JSON.parse(localStorage.getItem('curUser'));
  //   console.log(curUser);

  const submitHandler = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    const user = {
      name: name,
      phone_number: phone,
      address: address,
    };
    console.log(user);
    if (name && phone && address && doc) {
      //post request
      formData.append('file', doc);
      try {
        await axios
          .post(`/kyc/${curUser.user._id}`, user, {
            headers: { 'Access-Control-Allow-Origin': '*' },
            withCredentials: true,
          })
          .then(async (res) => {
            //Kyc id
            const id = res.data.id;
            // //For Image update
            try {
              await axios.put(`/kyc/uploaddoc/${id}`, formData, {
                headers: { 'Access-Control-Allow-Origin': '*' },
                withCredentials: true,
              });
              toast.success('Form Submitted!');
              window.location.href = '/';
            } catch (error) {
              // doc upload fail — KYC entry delete karo
              await axios.delete(`/kyc/${id}`, {
                headers: { 'Access-Control-Allow-Origin': '*' },
                withCredentials: true,
              });
              const msg = error.response?.data?.message || 'Document upload failed!';
              toast.error(msg);
            }
          });
      } catch (error) {
        console.log(error);
      }
    } else toast.error('Please fill the details!');
  };

  return (
    <div className={style.Register}>
      <p>Complete your kyc</p>
      <div className={style.details}>
        <p>Enter your details below to verify an account.</p>
      </div>
      <div className={style.section}>
        <p>Full Name</p>
        <input
          type='text'
          value={name}
          placeholder='hunter'
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      <div className={style.section}>
        <p>Phone Number</p>
        <input
          type='number'
          value={phone}
          placeholder='XXXXXXXXXX'
          onChange={(e) => setPhone(e.target.value)}
        />
      </div>
      <div className={style.section}>
        <p>Address</p>
        <input
          type='text'
          value={address}
          placeholder='Address'
          onChange={(e) => setAddress(e.target.value)}
        />
      </div>
      <div className={style.section}>
        <p>Document</p>
        <input
          type='file'
          fileName='file'
          onChange={(e) => setDoc(e.target.files[0])}
        />
      </div>
      <div className={style.Button} onClick={submitHandler}>
        Submit
      </div>
    </div>
  );
};

export default Kyc;
